import { MAPS } from "../game/constants/maps";
import { Button } from "../components/Button";

export function ResultScreen({ controller }) {
	const { ui, currentMap, actions, limits } = controller;
	const survival = ui.runMode === "survival";
	const victory = ui.screen === "victory";
	const mapComplete = ui.screen === "mapComplete";
	const nextMap = MAPS[ui.mapIdx + 1];

	return (
		<main className="result-screen">
			<section className="result-card" style={{ "--tone": victory ? "#7cf27f" : mapComplete ? currentMap.color : survival ? "#ffb657" : "#ff5c5c" }}>
				<div className="eyebrow">{survival ? "Survival Run Ended" : victory ? "Campaign Complete" : mapComplete ? "Map Cleared" : "Defeat"}</div>
				<h1>{survival ? "Lane Overrun" : victory ? "The Colony Holds" : mapComplete ? `${currentMap.name} Secured` : "Shield Collapse"}</h1>
				<p>
					{survival
						? `You held ${currentMap.name} through wave ${ui.wave} before the line broke.`
						: victory
						? "Every route is quiet. Command has the final score logged."
						: mapComplete
							? nextMap ? `Next sector: ${nextMap.name}.` : "All maps cleared."
							: `The line broke on ${currentMap.name}, wave ${ui.wave}.`}
				</p>
				<div className="result-stats">
					<span>Score <strong>{ui.score}</strong></span>
					<span>Lives <strong>{ui.lives}</strong></span>
					<span>{survival ? "Mode" : "Maps"} <strong>{survival ? "Survival" : `${victory ? limits.totalMaps : ui.mapIdx}/${limits.totalMaps}`}</strong></span>
					<span>Kills <strong>{ui.stats.kills || 0}</strong></span>
				</div>
				<div className="result-actions">
					{mapComplete && !survival && <Button tone="success" onClick={actions.advanceMap}>Next Map</Button>}
					{ui.screen !== "gameover" && <Button tone="primary" onClick={actions.save}>Save Results</Button>}
					<Button tone="ghost" onClick={actions.backToMenu}>Back To Menu</Button>
				</div>
			</section>
		</main>
	);
}
